




























import { computed, defineComponent, ref } from "@vue/composition-api";
import { AiUserQuestionaryField } from "@scrile/api-provider/dist/api/AiUserQuestionaryProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import useRole from "@/hooks/useRole";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { FormValues } from "@/types";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import PageTitle from "@/components/PageTitle";
import { fields } from "./config";

export default defineComponent({
  name: "PageAiQuestionary",
  components: { BasePage, BaseForm, PageTitle, BaseSpinner, BaseButton },
  props: {
    userId: { type: String, required: true },
  },
  setup(props, { root }) {
    const loading = ref(false);
    const sending = ref(false);
    const { authorities, authUser } = useAuthUser();
    const { isAdmin } = useRole(authUser);
    const isValid = ref(false);
    const formValues = ref<FormValues>({});

    const canUpdateAiQuestionary = computed(() =>
      checkAuthorities(authorities.value, [isAdmin.value ? "updateAnyAiUserQuestionary" : "updateMyAiUserQuestionary"])
    );

    const onBack = () => {
      root.$router.back();
    };
    const save = async () => {
      if (isValid.value && canUpdateAiQuestionary.value) {
        try {
          sending.value = true;
          await providers.AiUserQuestionaryProvider.update({
            data: { userId: props.userId, fields: formValues.value as Record<AiUserQuestionaryField, string> },
          });
          emitter.emit(EVENTS.NOTIFICATION_SHOW, {
            text: $t("Changes saved"),
          });
        } finally {
          sending.value = false;
        }
      }
    };

    const getData = async () => {
      try {
        loading.value = true;
        const response = await providers.AiUserQuestionaryProvider.search({ userId: props.userId });
        formValues.value = response?.fields ? response.fields : {};
      } finally {
        loading.value = false;
      }
    };

    getData();

    return { loading, sending, fields, formValues, isValid, save, onBack };
  },
});
